
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 15.6"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.7 6.7l1.5 1.5 1.6 1.6 1.6 1.6L10 9.8l1.5 1.6 1.6-1.6 1.6-1.6 1.6-1.5 1.5-1.6-1.5-1.6-1.6 1.6-1.6 1.6-1.6 1.5L10 9.8 8.4 8.2 6.8 6.7 5.2 5.1 3.7 3.5 2.1 5.1l1.6 1.6z"}}),_c('path',{attrs:{"d":"M11 5V0H8.8v6.7H11zM13.3 13.3H2.2v2.3H17.8v-2.3h-2.2zM2.2 11.1V8.9H0v4.4h2.2zM17.8 8.9v4.4H20V8.9z"}})])
          )
        }
      }
    